module.exports = __webpack_public_path__ + "img/neox.4ffd9e9e.svg";